declare let echarts: any;

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { IMessageChart } from '../../interfaces/message-chart.interface';

@Component({
  selector: 'sgt-message-chart',
  templateUrl: './message-chart.component.html',
  styleUrls: ['./message-chart.component.scss']
})
export class MessageChartComponent implements AfterViewInit, OnDestroy {
  @Input() chart: IMessageChart;

  @ViewChild('chartEl') chartEl: ElementRef;

  private chartInstance: any;
  private resizeObserver: ResizeObserver;

  ngAfterViewInit(): void {
    const options = {
      ...this.chart.options,
      title: undefined,
      toolbox: undefined,
      grid: { ...this.chart.options.grid as object, top: 10, right: 40 }
    };

    this.chartInstance = echarts.init(this.chartEl.nativeElement);
    this.chartInstance.setOption(options);

    this.resizeObserver = new ResizeObserver(() => this.chartInstance?.resize());
    this.resizeObserver.observe(this.chartEl.nativeElement);
  }

  onDownload(): void {
    if (!this.chartInstance) {
 return;
}
    const url = this.chartInstance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' });
    const link = document.createElement('a');
    link.href = url;
    link.download = (this.chart.title || 'grafico') + '.png';
    link.click();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.chartInstance?.dispose();
  }
}
